<template>
  <DeliveryPolicySection ref="deliveryPolicy"></DeliveryPolicySection>
</template>

<script>
  import DeliveryPolicySection from "./DeliveryPolicySection.vue";
  import BeforeRouteEnter from "./BeforeRouteEnter.js";

  export default {
    name: "DeliveryPolicyWrapper",
    components: {
      DeliveryPolicySection,
    },
    beforeRouteEnter: BeforeRouteEnter,
  };
</script>
